export const TRANSLATION_KEYS = {
    NOTIFICATION: "NOTIFICATION",
    FOLDER: "FOLDER",
    NEW_FOLDER: "NEW_FOLDER",
    TEXT_DOCUMENT: "TEXT_DOCUMENT",
    NEW_TEXT_DOCUMENT: "NEW_TEXT_DOCUMENT",
    SAVE: "SAVE",
    UNSAVE: "UNSAVE",
    CANCEL: "CANCEL",
    ICONS_VIEW: "ICONS_VIEW",
    CREATE: "CREATE",
    SMALL_ICONS: "SMALL_ICONS",
    MEDIUM_ICONS: "MEDIUM_ICONS",
    BIG_ICONS: "BIG_ICONS",
    FULL_SCREEN_ADVICE: "FULL_SCREEN_ADVICE",
    CHANGED: "CHANGED",
    SAVED: "SAVED",
    UNSAVE_TITLE: "UNSAVE_TITLE",
    UNSAVE_SUBTITLE: "UNSAVE_SUBTITLE",
    SHUT_DOWN_TITLE: "SHUT_DOWN_TITLE",
    RESTART_TITLE: "RESTART_TITLE",
    READ_ME: "READ_ME",
    KEYBOARD_LAYOUT: "KEYBOARD_LAYOUT",
    CHANGE_NAME: "CHANGE_NAME",
    DELETE: "DELETE",
    PINNED: "PINNED",
    NEW_TAB: "NEW_TAB",
    SETTINGS: "SETTINGS",
    POWER_MODAL: {
        LOCK: "LOCK",
        RESTART: "RESTART",
        SHUT_DOWN: "SHUT_DOWN",
    },
    SETTINGS_WINDOW: {
        PERSONALIZATION: "PERSONALIZATION",
        SYSTEM: "SYSTEM",
        DISPLAY: "DISPLAY",
        SYSTEM_LANGUAGE: "SYSTEM_LANGUAGE",
        SYSTEM_INFORMATION: "SYSTEM_INFORMATION",
        WALLPAPERS: "WALLPAPERS",
        DESKTOP: "DESKTOP",
        BRIGHTNESS: "BRIGHTNESS",
        NIGHT_MODE: "NIGHT_MODE",
        FILE: "FILE",
        SELECTION_FILE_COLOR: "SELECTION_FILE_COLOR",
        FILE_SIZE: "FILE_SIZE",
        FILE_SIZE_SMALL: "FILE_SIZE_SMALL",
        FILE_SIZE_MEDIUM: "FILE_SIZE_MEDIUM",
        FILE_SIZE_LARGE: "FILE_SIZE_LARGE",
        SELECTION_AREA: "SELECTION_AREA",
        SELECTION_AREA_BORDER_COLOR: "SELECTION_AREA_BORDER_COLOR",
        SELECTION_AREA_COLOR: "SELECTION_AREA_COLOR",

    },
    PROPERTIES: "PROPERTIES",
    PROPERTIES_WINDOW: {
        TYPE: "TYPE",
        SIZE: "SIZE",
        UPDATED_AT: "UPDATED_AT",
        CREATED_AT: "CREATED_AT",
    },
    BIN: "BIN",
} as const;